import parsePhoneNumber from "libphonenumber-js";
import type { PhoneNumber } from "libphonenumber-js";

export function getNationalPhonenumber(phone?: string, code?: string): string {

    let phonenumber = "";

    code = code || "82";

    if (!phone) { return "" }

    try {
        const parsePhone = parsePhoneNumber(`+${code} ${phone}`) as PhoneNumber;
        phonenumber = parsePhone.isValid() && parsePhone.formatNational() ? parsePhone.formatNational() : phone
    } catch {
        phonenumber = phone
    }

    return phonenumber.replace(/\-/g, '')
}

export function getInternationalPhonenumber(phone?: string, code?: string, minify = true) {
    let phonenumber = "";
    code = code || "82";

    if (!phone) { return '' };

    try {
        const parsePhone = parsePhoneNumber(`+${code} ${phone}`) as PhoneNumber;
        phonenumber = parsePhone.isValid() && parsePhone.formatInternational() ? parsePhone.formatInternational() : phone
    } catch {
        phonenumber = phone
    }

    if (minify) {
        phonenumber = phonenumber.replace(/ /g, '');
        phonenumber = phonenumber.replace(code, '');
        phonenumber = phonenumber.replace("+", '');
    }

    return phonenumber
}